/*
  BNH — Görsel büyütme penceresini "seçici" hâline getirir.

  Tema pencereyi dikey bir yığın olarak basıyor: sekiz görseli
  görmek için sekiz ekran kaydırmak gerekiyor. Burada aynı DOM
  üzerinde tek seferde tek görsel gösteriliyor; solda (mobilde
  altta) küçük görsel şeridi, iki yanda ok düğmeleri var.

  Tema HTML'ine dokunmuyoruz: yalnızca görünür olan medya
  kutularını sayıp aralarında geçiş yapıyoruz. Renk filtresi
  (hide_variants) bazı kutuları gizlediği için şerit pencere her
  açıldığında yeniden kuruluyor.
*/
(function () {
  var modal, stage, rail, prevBtn, nextBtn, items = [], index = 0;

  function visibleItems() {
    if (!stage) return [];
    return Array.prototype.filter.call(stage.children, function (el) {
      if (!el.dataset || !el.dataset.mediaId) return false;
      return getComputedStyle(el).display !== 'none' ||
        el.classList.contains('nb-lb-item');
    });
  }

  /* Şerit için küçük sürüm: Shopify genişlik parametresini düşür. */
  function thumbSrc(el) {
    var img = el.querySelector('img');
    if (!img) return '';
    var src = img.getAttribute('src') || img.currentSrc || '';
    return src.replace(/width=\d+/, 'width=200');
  }

  function isVideo(el) {
    return el.tagName === 'DEFERRED-MEDIA' ||
      !!el.querySelector('video, .deferred-media__poster');
  }

  function build() {
    stage = modal.querySelector('.product-media-modal__content');
    if (!stage) return false;

    /* Önceki kurulumu temizle (renk değişmiş olabilir). */
    Array.prototype.forEach.call(stage.children, function (el) {
      el.classList.remove('nb-lb-item', 'nb-lb-current');
    });

    items = visibleItems();
    if (items.length < 1) return false;

    items.forEach(function (el) { el.classList.add('nb-lb-item'); });
    stage.classList.add('nb-lb-stage');

    /* Açılışta hangi görsel seçilmişse ondan başla. */
    var start = items.findIndex(function (el) {
      return el.classList.contains('is-active');
    });
    index = start > -1 ? start : 0;

    buildRail();
    buildArrows();
    show(index);

    /* Kalanları boşta kalınca yükle: gezinme akıcı olsun. */
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); };
    idle(function () {
      for (var n = 0; n < items.length; n++) prime(n);
    });
    return true;
  }

  function buildRail() {
    var host = modal.querySelector('[role="dialog"]') || modal;
    if (rail && rail.parentNode) rail.parentNode.removeChild(rail);

    rail = document.createElement('div');
    rail.className = 'nb-lb-rail';

    items.forEach(function (el, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nb-lb-thumb';
      b.setAttribute('aria-label', 'Görsel ' + (i + 1));

      var src = thumbSrc(el);
      if (src) {
        var im = document.createElement('img');
        im.src = src;
        im.alt = '';
        im.loading = 'lazy';
        b.appendChild(im);
      }
      if (isVideo(el)) b.classList.add('nb-lb-thumb--video');

      b.addEventListener('click', function () { show(i); });
      rail.appendChild(b);
    });

    host.appendChild(rail);
  }

  function buildArrows() {
    var host = modal.querySelector('[role="dialog"]') || modal;

    if (!prevBtn) {
      prevBtn = arrow('prev', 'Önceki görsel', 'M14 4 7 12l7 8');
      nextBtn = arrow('next', 'Sonraki görsel', 'M8 4l7 8-7 8');
      prevBtn.addEventListener('click', function () { show(index - 1); });
      nextBtn.addEventListener('click', function () { show(index + 1); });
    }
    if (prevBtn.parentNode !== host) {
      host.appendChild(prevBtn);
      host.appendChild(nextBtn);
    }
  }

  function arrow(dir, label, path) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nb-lb-arrow nb-lb-arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
      '<path d="' + path + '" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    return b;
  }

  /* Gizli kutulardaki görseller loading="lazy" olduğu için ekrana
     gelene kadar indirilmiyor; geçişte boş kare görünüyordu.
     Komşuları önden yüklüyoruz. */
  function prime(n) {
    if (!items.length) return;
    var el = items[(n + items.length) % items.length];
    if (!el) return;
    var img = el.querySelector('img');
    if (img && img.getAttribute('loading') !== 'eager') {
      img.setAttribute('loading', 'eager');
    }
  }

  function show(i) {
    if (!items.length) return;
    if (i < 0) i = items.length - 1;
    if (i > items.length - 1) i = 0;
    index = i;

    items.forEach(function (el, n) {
      el.classList.toggle('nb-lb-current', n === index);
    });

    if (rail) {
      var thumbs = rail.querySelectorAll('.nb-lb-thumb');
      for (var n = 0; n < thumbs.length; n++) {
        var on = n === index;
        thumbs[n].classList.toggle('is-active', on);
        thumbs[n].setAttribute('aria-current', on ? 'true' : 'false');
      }
      if (thumbs[index]) {
        thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    prime(index);
    prime(index + 1);
    prime(index - 1);
    if (stage) stage.scrollTop = 0;
  }

  function onKey(e) {
    if (!modal || !modal.hasAttribute('open')) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
  }

  function init() {
    modal = document.querySelector('product-modal.product-media-modal');
    if (!modal) return;

    var mo = new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        /* Tema açılışta ilgili medyaya kaydırıyor; ondan sonra kur. */
        setTimeout(build, 60);
        setTimeout(build, 400);
      }
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['open'] });

    document.addEventListener('keydown', onKey);

    if (modal.hasAttribute('open')) setTimeout(build, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
